import { reactive } from 'vue'
import { Message } from 'view-design'
import { AUTO_ACQUISITION_STATUS, EMPTY_VALUE } from '../consts/index.js'

export const getForm = () => ({
  budgetValue: '',
  budgetType: 1,
  unitType: 1
})

export function useBatchForm(props, emit, checkValidRow) {
  const form = reactive(getForm())

  const onBudgetValueConfirm = () => {
    const budgetValue = Number(form.budgetValue)

    if (budgetValue === 0) return
    if (typeof budgetValue !== 'number' || isNaN(budgetValue)) return Message.warning('请输入数字')
    if (budgetValue < 0) return Message.warning('预算须大于0')

    const newRows = props.rows.map((row) => {
      if (checkValidRow(row)) {
        return {
          ...row,
          autoAcquisitionNewBudget: budgetValue
        }
      }
      return row
    })

    emit('update:rows', newRows)
  }

  const removeAllBudgetValue = () => {
    form.budgetValue = ''
    emit(
      'update:rows',
      props.rows.map((row) => ({ ...row, autoAcquisitionNewBudget: EMPTY_VALUE }))
    )
  }

  const onGlobalUnableAction = () => {
    const newList = props.rows.map((row) => {
      if (row.raiseStatus === AUTO_ACQUISITION_STATUS.ENABLE) {
        return {
          ...row,
          autoAcquisitionNewBudget: 0
        }
      }
      return row
    })
    emit('update:rows', newList)
  }

  const removeRow = (index) => {
    const newList = props.rows.filter((_, i) => i !== index)
    emit('update:rows', newList)
  }

  const resetForm = () => {
    Object.assign(form, getForm())
  }

  return {
    form,
    onBudgetValueConfirm,
    removeAllBudgetValue,
    onGlobalUnableAction,
    removeRow,
    resetForm
  }
}
